export const constants = {
  UserKeys: [
    'username',
    'email',
    'displayname',
    'accType',
    'Role',
    'countrycode',
  ],
  IAMRole: {
    user: 'PP_SSO_DZ_USER',
    sharer: 'PP_SSO_DZ_SHARER',
    msgSender: 'PP_SSO_DZ_MSG_SENDER',
    cocUser: 'PP_SSO_DZ_COC_USER',
    cocSharer: 'PP_SSO_DZ_COC_SHARER',
  },
  Users: {
    user: 'User',
    sharer: 'Share',
  },
  IsIAMRoleEnabled: true,
  CorpUser: 'paypalcorp',
  GoPayUser: 'gopayinc',
  AdhocUser: 'adhoc',
  corpKey: 'internal',
  adhocKey: 'external',
  HeaderMenu: [
    {
      name: 'Home',
      key: 'home',
      url: 'action/search',
      display: true,
      localizeId: 'homeMenu',
    },
    {
      name: 'Shared by me',
      key: 'sharedbyme',
      url: 'action/search',
      display: false,
      localizeId: '',
    },
    {
      name: 'Shared with me',
      key: 'sharedwithme',
      url: 'action/search',
      display: false,
      localizeId: '',
    },
    {
      name: 'Favourites',
      key: 'favourites',
      url: 'favourites',
      display: false,
      localizeId: '',
    },
    {
      name: 'Recent Files',
      key: 'recentfiles',
      url: 'action/search',
      display: false,
      localizeId: '',
    },
    {
      name: 'My Uploads',
      key: 'myuploads',
      url: 'action/search',
      display: false,
      localizeId: '',
    },
  ],
  View: 'list',
  ViewTypes: [
    { name: 'Grid', key: 'grid', icon: 'ppvx_icon-menu', display: false },
    { name: 'List', key: 'list', icon: 'ppvx_icon-list-simple', display: true },
  ],
  ShowViews: false,
  GridViewBackOptions: ['size', 'modifiedDate'],
  showSavedSearchBoxOnFilter: false,
  Filters: {
    savedSearch: [
      {
        labelKey: 'labels.allFiles',
        value: 'All Files',
        key: 'allFiles',
      },
      {
        labelKey: 'labels.sharedBy',
        value: 'Shared by Me',
        key: 'sharedBy',
      },
      {
        labelKey: 'labels.sharedWith',
        value: 'Shared with me',
        key: 'sharedWith',
      },
    ],
    sortBy: [
      { name: 'Name', key: 'fileName' },
      { name: 'Size', key: 'size' },
      { name: 'Type', key: 'fileType' },
      { name: 'Date Created', key: 'createdDate' },
      { name: 'Date Modified', key: 'modifiedDate' },
    ],
    sortType: [
      { name: 'Sort by ascending', key: 'asc' },
      { name: 'Sort by descending', key: 'desc' },
    ],
  },
  AdvancedFilter: [
    { name: 'File Name', key: 'fileName', column: 1, localizeId: 'fileName' },
    { name: 'Path', key: 'path', column: 1, localizeId: 'path' },
    { name: 'Type', key: 'fileType', column: 3, localizeId: 'type' },
    { name: 'Size', key: 'size', column: 2, localizeId: 'size' },
    { name: 'Shared', key: 'isShared', column: 2, localizeId: 'isShared' },
    {
      name: 'Shared With',
      key: 'sharedWith',
      column: 1,
      localizeId: 'sharedWith',
    },
    { name: 'Shared By', key: 'sharedBy', column: 1, localizeId: 'sharedBy' },
  ],
  AdvancedFilterAdhoc: [
    { name: 'File Name', key: 'fileName', column: 1, localizeId: 'fileName' },
    { name: 'Path', key: 'path', column: 1, localizeId: 'path' },
    { name: 'Type', key: 'fileType', column: 3, localizeId: 'type' },
    { name: 'Size', key: 'size', column: 2, localizeId: 'size' },
    { name: 'Shared By', key: 'sharedBy', column: 1, localizeId: 'sharedBy' },
  ],
  AppliedFilter: 'notify',
  FileType: [
    {
      labelKey: 'filter.all',
      value: 'All',
      key: 'all',
    },
    {
      labelKey: 'filter.file',
      value: 'File',
      key: 'file',
    },
    {
      labelKey: 'filter.folder',
      value: 'Folder',
      key: 'folder',
    },
  ],
  DiskUsageValue: {
    warning: 7000000000,
    alert: 10000000000,
  },
}
